import get from "lodash/get";
import omitBy from "lodash/omitBy";
import isNil from "lodash/isNil";

export const _ = { get, omitBy, isNil };
